/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./reward.vue?vue&type=template&id=9d822d38"
import script from "./reward.vue?vue&type=script&lang=js"
export * from "./reward.vue?vue&type=script&lang=js"
import style0 from "./reward.vue?vue&type=style&index=0&id=9d822d38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports